import React, { forwardRef } from "react";
import { Input } from "@/components/ui";

interface FileInputProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  multiple?: boolean;
}

export const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ onChange, multiple = true }, ref) => {
    return (
      <Input
        type="file"
        className="fixed -top-4 -left-4 size-0.5 opacity-0 pointer-events-none"
        ref={ref}
        multiple={multiple}
        onChange={onChange}
        tabIndex={-1}
      />
    );
  }
);

FileInput.displayName = "FileInput";
